require('@jimdo/angular-fontselect-typesquare/dist/angular-fontselect-typesquare-frontend.js');

(function($, jimdoData) {
  'use strict';

  $(function() {
    $.angularFontselectUpdateTypesquare(jimdoData.dmp.typesquareFontApiScriptUrl);
  });
})(require('jquery'), require('jimdoData'));



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/plugins/typesquare.init.js
 ** module id = 1737
 ** module chunks = 106 252
 **/